import { render, staticRenderFns } from "./unallocated.vue?vue&type=template&id=9607fa06&scoped=true"
import script from "./unallocated.vue?vue&type=script&lang=js"
export * from "./unallocated.vue?vue&type=script&lang=js"
import style0 from "./unallocated.vue?vue&type=style&index=0&id=9607fa06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9607fa06",
  null
  
)

export default component.exports